module.exports = __webpack_public_path__ + "img/tops-boothals.6eb44572.png";